/* tslint:disable */
/* eslint-disable */
/**
 * InnerAnalytics MNT Server
 * InnerAnalytics MNT server API specification.
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */



/**
 * 
 * @export
 * @enum {string}
 */

export const AdvisorChatSubjectTypeEnum = {
    General: 'general',
    PatientDailyInsight: 'patient_daily_insight',
    SmsMessage: 'sms_message',
    PinnedHealthTargets: 'pinned_health_targets',
    ClientPrompt: 'client_prompt',
    MealReflection: 'meal_reflection'
} as const;

export type AdvisorChatSubjectTypeEnum = typeof AdvisorChatSubjectTypeEnum[keyof typeof AdvisorChatSubjectTypeEnum];



